import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import ContactForm from "../components/Contact/ContactForm";
import ServiceThree from "../components/Services/ServiceThree";

const services = [
  {
    icon: "/assets/images/Vector.webp",
    title: "Automation & Logistics",
    description:
      "Seamless last-mile delivery enabled by automated dispatch, microservices, synchronized databases, and data lakes for centralized insights.",
    delay: "0",
    slug: "automation-logistics",
  },
  {
    icon: "/assets/images/Vector-1.webp",
    title: "Cloud Migration",
    description:
      "Moving to the cloud doesn't have to be complicated. We design and execute robust migration strategies, covering environment setup, agent installation, continuous replication, test launches, acceptance testing, scheduled cutovers, and final deployment.",
    delay: "100",
    slug: "cloud-migration",
  },
  {
    icon: "/assets/images/Vector-2.webp",
    title: "Optimized Customer Onboarding",
    description:
      "This service re-engineers and automates the customer onboarding journey with customized back-end solutions for faster, more accurate, and seamless experiences.",
    delay: "200",
    slug: "customer-onboarding",
  }
];

export default function Services() {
  return (
    <InnerPageLayout>
      <BreadCrumb pageTitle="Services" items={[{ label: "Services", path: "/services" }]} />
      <ServiceThree services={services} showChip={false} />
      <ContactForm cardGrid={false} />
      {/* <CtaOne /> */}
    </InnerPageLayout>
  );
}
